/** Keeps the screen awake while a phase runs (opt-in). Re-acquired when the tab becomes visible. */
let sentinel: WakeLockSentinel | null = null;
let wanted = false;
let pending = false;

export const wakeLockSupported = () => 'wakeLock' in navigator;

async function acquire() {
  if (!wanted || sentinel || pending || document.hidden || !wakeLockSupported()) return;
  pending = true;
  try {
    const lock = await navigator.wakeLock.request('screen');
    // Paused while the request was in flight: let go right away instead of keeping the screen on.
    if (!wanted) return void lock.release().catch(() => {});
    sentinel = lock;
    lock.addEventListener('release', () => {
      if (sentinel === lock) sentinel = null;
    });
  } catch {
    sentinel = null;
  } finally {
    pending = false;
  }
}

export function setWakeLock(on: boolean) {
  wanted = on;
  if (on) void acquire();
  else if (sentinel) {
    void sentinel.release().catch(() => {});
    sentinel = null;
  }
}

document.addEventListener('visibilitychange', () => void acquire());
